import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormModule } from '@spaq/shared/components/forms';
import { MessageStateModule } from '@spaq/shared/components/message-state';
import { SharedCommonModule, SharedComponentsModule, SharedFormModule } from '@spaq/shared';
import {
	ForgotPasswordConfirmChangeComponent,
	PasswordDetailsComponent,
	PasswordEditComponent,
	PasswordForgotComponent,
	PasswordForgotFormComponent,
	PasswordForgotResetComponent,
	PasswordForgotSuccessComponent,
	PasswordForgotWaitComponent,
	PasswordResetFormComponent,
	UpdatePasswordComponent
} from './components';

import { ForgotPasswordComponent, ForgotPasswordPendingComponent, ForgotPasswordResetComponent } from './pages';

@NgModule({
	imports: [SharedCommonModule, SharedComponentsModule, FormModule, MessageStateModule, SharedFormModule],
	declarations: [
		PasswordEditComponent,
		UpdatePasswordComponent,
		PasswordDetailsComponent,
		PasswordForgotComponent,
		PasswordForgotFormComponent,
		PasswordForgotSuccessComponent,
		PasswordForgotWaitComponent,
		PasswordForgotResetComponent,
		PasswordResetFormComponent,
		ForgotPasswordConfirmChangeComponent,
		ForgotPasswordResetComponent,
		ForgotPasswordComponent,
		ForgotPasswordPendingComponent
	],
	exports: [
		PasswordEditComponent,
		UpdatePasswordComponent,
		PasswordDetailsComponent,
		PasswordForgotComponent,
		PasswordForgotFormComponent,
		PasswordForgotSuccessComponent,
		PasswordForgotWaitComponent,
		PasswordForgotResetComponent,
		PasswordResetFormComponent
	]
})
export class PasswordModule {
	static forRoot(): ModuleWithProviders<PasswordModule> {
		return {
			ngModule: PasswordModule,
			providers: []
		};
	}
}
